import {inject, Injectable} from "@angular/core";
import {Meta, Title} from "@angular/platform-browser";
import {ActivationEnd, Router} from "@angular/router";
import {filter, map, of, switchMap} from "rxjs";
import {regionList} from "./divisions.service";
import {Database, objectVal, ref} from "@angular/fire/database";

const year = new Date().getUTCFullYear();
const DEFAULT_DESCRIPTION = `Are divisions out yet? Get all the details about teams attending ${year} FIRST Robotics Competition Championships and register to be notified when divisions are released.`;

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  private readonly router = inject(Router);
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);
  private readonly db = inject(Database);

  constructor() {
    this.router.events.pipe(
      filter((e): e is ActivationEnd => e instanceof ActivationEnd),
      filter(e => !!e.snapshot?.component && !e.snapshot?.children?.length),
      switchMap(e => {
        const snap = e.snapshot;
        const regionKey = snap.params?.['regionKey'];
        const regionName = regionList.find(r => r.key === regionKey)?.name || ''
        const divisionKey = snap.params?.['divisionKey'];
        let prefix = snap.data?.['title'] ? `${snap.data['title']} | ` : '';

        const description = snap.data?.['description']?.replaceAll('{year}', year)?.replaceAll('{regionName}', regionName) || DEFAULT_DESCRIPTION;

        if(regionName) {
          prefix += `${regionName} | `;
        }

        if(divisionKey) {
          return objectVal<string|null>(ref(this.db, `regions/${regionKey}/divisions/${divisionKey}/name`)).pipe(map(name => ({title: `${snap.data?.['title'] ? `${snap.data['title']} | ` : ''}${name} | ${regionName} | FRC Division Notifier`, description: description.replaceAll('{divisionName}', name)})));
        }

        return of({title: `${prefix}FRC Division Notifier`, description});
      }),
    ).subscribe(meta => {
      this.title.setTitle(meta.title);
      this.meta.updateTag({name: 'description', content: meta.description});
    });
  }
}
